interface IParams {
  isArchived: boolean;
  isFromXml: boolean;
  isDealRent: boolean;
}

export const getQuery = (params: IParams): string | undefined => {
  const {
    isArchived,
    isFromXml,
    isDealRent,
  } = params;

  const queryParams: TStringObject = {};

  // Параметр неактуален при сохранении черновика
  if (isArchived) {
    queryParams.isArchived = 'true';
  }

  if (isFromXml) {
    queryParams.isFromXML = '1';
  }

  if (isDealRent) {
    queryParams.isDealRent = '1';
  }

  if (!Object.keys(queryParams).length) {
    return undefined;
  }

  return '?' + Object.keys(queryParams).map(key => `${key}=${queryParams[key]}`).join('&');
};
